exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inline-btn[data-v-711fb454] {\n  margin: -8px -4px -8px 0;\n}\n", ""]);

